export type AppEnvironment = "development" | "staging" | "production" | "test";

export function parseAppEnvironment(value: string | undefined): AppEnvironment {
  const normalized = (value ?? "development").trim().toLowerCase();
  if (!["development", "staging", "production", "test"].includes(normalized)) {
    throw new Error("REACT_APP_APP_ENV doit être development, staging, production ou test.");
  }
  return normalized as AppEnvironment;
}

export function validateBackendForEnvironment(environment: AppEnvironment, backendUrl: string): void {
  if (["staging", "production"].includes(environment)) {
    if (backendUrl === "/api") return;
    const url = new URL(backendUrl);
    const hostname = url.hostname.toLowerCase();
    const local = hostname === "localhost" || hostname.endsWith(".localhost") ||
      hostname === "0.0.0.0" || hostname === "[::1]" || hostname === "::1" ||
      /^127(?:\.\d{1,3}){3}$/.test(hostname);
    if (url.protocol !== "https:" || local) {
      throw new Error("Le backend STAGING/Production doit utiliser une URL HTTPS non locale.");
    }
  }
  if (environment === "staging" && backendUrl.toLowerCase().includes("trycloudflare.com")) {
    throw new Error("STAGING ne peut pas utiliser un Quick Tunnel temporaire.");
  }
}
